<template>
  <div class="text-xs font-semibold text-surface-500 mt-5 mb-2 mx-1">
    <slot />
  </div>
</template>
